import React, { useState } from "react";
import { SecurityTextInput } from "../../../../../Formik/FormLib";
import {
  StyledBankTransferFormButton,
  ButtonGroup,
  colors,
} from "../../../../../../Syles/styles";
import { Formik, Form } from "formik";
import Loader from "react-loader-spinner";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { $api } from "../../../../../../../helpers/$api";

const Security = () => {
  const [error, setError] = useState("");
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setError("");
      setSubmitting(true);
      await $api.user.changePassword(values);
      toast.success("Password updated");
    } catch (error) {
      setError(error.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        width: "90%",
        margin: "auto",
        marginTop: "20px",
      }}
    >
      <h2>Security</h2>
      <Formik
        initialValues={{
          currentpassword: "",
          newpassword: "",
        }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object({
          current_password: Yup.string()
            .min(8, "password is too short")
            .max(30, "password is too long")
            .required("Password is Required"),
          new_password: Yup.string()
            .min(8, "password is too short")
            .max(30, "password is too long")
            .required("Password is Required"),
        })}
      >
        {({ isSubmitting }) => (
          <Form>
            <center>
              <p style={{ color: "red" }}>{error}</p>
            </center>
            <p
              style={{
                color: "#121212",
                fontSize: "1.6rem",
                lineHeight: "1.9rem",
                textAlign: "left",
                marginTop: "25px",
              }}
            >
              Current Password
            </p>
            <SecurityTextInput name="current_password" type="password" />
            <p
              style={{
                color: "#121212",
                fontSize: "1.6rem",
                lineHeight: "1.9rem",
                textAlign: "left",
                marginTop: "25px",
              }}
            >
              New Password
            </p>

            <SecurityTextInput name="new_password" type="password" />
            <ButtonGroup>
              {!isSubmitting && (
                <StyledBankTransferFormButton type="submit">
                  Update Password
                </StyledBankTransferFormButton>
              )}

              {isSubmitting && (
                <Loader
                  type="ThreeDots"
                  color={colors.primary}
                  height={49}
                  width={100}
                />
              )}
            </ButtonGroup>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Security;
